import {flow, Instance, ISimpleType, types as t} from 'mobx-state-tree'
import {union} from 'lodash-es'
import {Permission, PermissionCondition, satisfyCondition} from 'admin/permissions'
import {injectFromEnv} from './injectors'

const RoleManager = injectFromEnv('roleProviders')
.named('RoleManager')
.props({
  /**
   * Все доступные роли с правами в системе
   */
  roles: t.map(t.model({
    title: t.string,
    permissions: t.array(t.string)
  }))
})
.views((self) => {
  const views = {
    /**
     * Возвращает все permission, доступные в системе
     */
    get permissions () {
      return Array.from(self.roles.values()).reduce<Permission[]>(
        (result, role) => union(role.permissions, result),
        []
      )
    },

    /**
     * Возвращает все роли, удовлетворяющие заданному условию
     */
    getRolesByPermissions (permission: PermissionCondition) {
      return Array
        .from(self.roles.keys())
        .filter((role) => satisfyCondition(permission, self.roles.get(role).permissions))
    }
  }

  return views
})
.actions((self) => {
  const actions = {
    /**
     * Загрузить доступные роли
     */
    loadRoles: flow(function * () {
      const roles = yield self.$env.roleProviders.ctt.fetchRoles()
      self.roles = roles
    })
  }

  return actions
})

export default RoleManager
export type RoleManagerType = Instance<typeof RoleManager>
